import React from 'react';
import { Lock, Unlock } from 'lucide-react';
import { motion } from 'framer-motion';

interface PrivacyLockScreenProps {
  isLocked?: boolean;
  onToggle?: () => void;
  className?: string;
  iconSize?: number;
}

const PrivacyLockScreen: React.FC<PrivacyLockScreenProps> = ({ 
  isLocked = false, 
  onToggle, 
  className = "",
  iconSize = 16
}) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onToggle}
      className={`p-2 rounded-full backdrop-blur-xl border transition-all duration-300 ${className} ${
        isLocked 
          ? "bg-red-500/20 border-red-400/40 text-red-300 hover:bg-red-500/30" 
          : "bg-green-500/20 border-green-400/40 text-green-300 hover:bg-green-500/30"
      }`}
      aria-label={isLocked ? "Unlock screen" : "Lock screen"}
      title={isLocked ? "Click to unlock screen" : "Click to lock screen (Ctrl+L)"}
    >
      {isLocked ? <Lock size={iconSize} /> : <Unlock size={iconSize} />}
    </motion.button>
  );
};

export default PrivacyLockScreen;



